// Entry point for ES6+ modules

import common from './common.js';
import { _ua, isMobileDevice, getGSAP } from './utils.js';
import LenisController from './lenis-controller.js';
import MenuController from './menu-controller.js';
import SAI from './sai.js';
import tab from './tab.js';

// UI Components
import acod from './acod.js';
import Modal from '../../components/modal/modal.js';

import parallaxPhoto from '../../components/parallaxPhoto/parallaxPhoto.js';
import footerEntry from '../../components/footerEntry/footerEntry.js';
import TopPage from '../../../js/_function.js';
import swipeFigure from '../../components/swipeFigure/swipeFigure.js';
import generalSlider from '../../components/generalSlider/generalSlider.js';
import zoomFigure from '../../components/zoomFigure/zoomFigure';
import LocationPage from '../../../location/js/_function.js';
import autoPlaySlider from '../../components/autoPlaySlider/autoPlaySlider.js';
import FeaturePage from '../../../feature/js/_function.js';

// Controller instances (for cleanup in SPA or dynamic scenarios)
let lenisInstance = null;

// Initialize common functionality
document.addEventListener('DOMContentLoaded', () => {
  new common();

  // Initialize Lenis smooth scroll (PCのみ)
  lenisInstance = new LenisController();

  // Initialize global navigation menu (PC/SP common)
  new MenuController();

  // Initialize UI components
  new acod();
  new tab();
  new Modal({ lenisController: lenisInstance });

  // Initialize SAI (Scroll Animation Interface)
  new SAI();

  // ParallaxPhoto
  new parallaxPhoto();

  // SwipeFigure
  new swipeFigure();

  // GeneralSlider
  new generalSlider();

  // AutoPlaySlider
  new autoPlaySlider();

  // ZoomFigure
  new zoomFigure();
  // FooterEntry
  new footerEntry();

  // トップページのみ（#top）：MV / ScrollFadeBg / Swiper 等
  if (document.getElementById('top')) {
    new TopPage();
  }
  // ロケーションページ
  if (document.getElementById('location')) {
    new LocationPage();
  }

  if (document.getElementById('feature')) {
    new FeaturePage({ lenisController: lenisInstance });
  }

  // PCのみ: ページ内の全画像読み込み完了後にScrollTriggerを再計算
  // モバイルではScrollTriggerを使用しないためスキップ
  if (!isMobileDevice()) {
    refreshScrollTriggerOnImagesLoad();
  }
});

/**
 * ページ内の画像読み込みを監視してScrollTriggerを再計算（PCのみ）
 * lazy loading画像も含めて監視する
 */
async function refreshScrollTriggerOnImagesLoad() {
  // 共通GSAP初期化を使用
  const { ScrollTrigger } = await getGSAP();

  // lazy loading画像の読み込み完了を監視
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');

  if (lazyImages.length > 0) {
    // IntersectionObserverでlazy画像の読み込みを検知
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            // 画像が読み込まれたらrefresh
            if (img.complete) {
              ScrollTrigger.refresh();
            } else {
              img.addEventListener(
                'load',
                () => {
                  ScrollTrigger.refresh();
                },
                { once: true }
              );
            }
            observer.unobserve(img);
          }
        });
      },
      {
        rootMargin: '200px' // 少し手前で検知
      }
    );

    lazyImages.forEach(img => observer.observe(img));
  }

  // window.load時にも再計算（フォールバック）
  window.addEventListener(
    'load',
    () => {
      setTimeout(() => ScrollTrigger.refresh(), 200);
    },
    { once: true }
  );
}

/**
 * Cleanup function for SPA or dynamic page scenarios
 * Call this before page unmount to prevent memory leaks
 */
export function destroyScrollAnimations() {
  if (lenisInstance) {
    lenisInstance.destroy();
    lenisInstance = null;
  }
}

// Export for potential use in other modules
export {
  common,
  _ua,
  LenisController,
  MenuController,
  SAI,
  acod,
  tab,
  Modal,
  parallaxPhoto,
  footerEntry
};
